export const RequestStatusesConstant = {
    ADD: 1,
    APPROVED: 2,
    CANCELLED: 3,
    COMPLETED: 4
}